/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  // 只有管理员可以访问，检查 access 字段是否为 'admin'
  return {
    canAdmin: currentUser && currentUser.access === 'admin',
  };
}
